import { Injectable, inject } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve } from "@angular/router";
import { Observable, of } from "rxjs";
import { Dashboard } from "../models/dashboard";
import { DashboardStore } from "../stores/dashboard.store";
import { DashboardFactory } from "../factory/dashboard.factory";

/**
 * Ein Resolver, der vor dem Laden einer Route ein Dashboard-Objekt bereitstellt.
 * 
 * Wenn eine gültige Dashboard-ID in der URL vorhanden ist, wird das entsprechende
 * Dashboard aus dem Store geladen. Andernfalls wird ein Standard-Willkommens-Dashboard
 * erzeugt und zurückgegeben.
 */
@Injectable({ providedIn: 'root' })
export class DashboardResolver implements Resolve<Dashboard> {
  // Den DashboardStore mithilfe des neuen Angular-inject-APIs injizieren
  private store = inject(DashboardStore);

  /**
   * Wird vom Router aufgerufen, bevor die Route aktiviert wird.
   * @param route - Der Snapshot der aktuellen Route, aus dem wir Parameter auslesen
   * @returns Ein Observable, das ein Dashboard-Objekt liefert
   */
  resolve(route: ActivatedRouteSnapshot): Observable<Dashboard> {
    // Versuche, die "id"-Route-Param als String auszulesen
    const id = route.paramMap.get('id');

    // Prüfen, ob eine gültige ID gefunden wurde (Number(id) ergibt eine positive Zahl)
    if (id && Number(id) && Number(id) > 0) {
      // Lade das Dashboard mit der angegebenen ID aus dem Store (liefert ein Observable<Dashboard>)
      return this.store.loadDashboardById(Number(id));
    } else {
       // -1: Erzeuge und gebe ein statisches "Welcome"-Dashboard zurück
      if(Number(id) === -1)
        return of(DashboardFactory.createWelcomeDashboard());
      // Keine gültige ID: Erzeuge und gebe ein leeres Dashboard zurück
      return of(DashboardFactory.createEmpty());
    }
  }
}
